/* eslint-disable sonarjs/no-collapsible-if */
/* eslint-disable @nx/enforce-module-boundaries */
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import {
  AppstateService,
  AppstateFacade,
} from '@cigna/cigna-for-brokers/shell/data-access';
import { LoginFacade } from '@cigna/cigna-for-brokers/login-data-access';
import { takeUntil, Subject, map } from 'rxjs';
import { FeatureTogglesFacade } from '@cigna/shared/angular/features-feature';
import { ContactUsComponent } from '@cigna/cigna-for-brokers/shared/ui';
import { MatDialog } from '@angular/material/dialog';
import { Menu } from '@cigna/cigna-for-brokers/shared/util';

@Component({
  selector: 'cigna-caheader-impersonator',
  templateUrl: './header-impersonator.component.html',
  styleUrls: ['./header-impersonator.component.scss'],
})
export class HeaderImpersonatorComponent implements OnInit, OnDestroy {
  @Input() isImpersonationUser: boolean;
  @Input() isImpersonatorSignin: boolean;
  @Input() canEnableImpersonatorLogout: boolean;
  @Input() impFirstName: string | undefined;
  @Input() impLastName: string | undefined;
  @Input() operatorId: string | undefined;
  @Input() menuItemsWithSubMenu?: Menu[];

  private _ngUnsubscribe$: Subject<void> = new Subject<void>();
  isOktaLoginEnabled: boolean;
  isUsEmployerOnly = false;
  isOktaLoginEnabled$ = this.featureTogglesFacade.featuresEnabled([
    'isOktaLoginEnabled',
  ]);

  constructor(
    private appStateFacade: AppstateFacade,
    private featureTogglesFacade: FeatureTogglesFacade,
    public _loginFacade: LoginFacade,
    public dialog: MatDialog,
    private appstateService: AppstateService,
  ) {}

  ngOnInit() {
    this.isOktaLoginEnabled$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((isOktaLoginEnabled: boolean) => {
        this.isOktaLoginEnabled = isOktaLoginEnabled;
      });

    this.isUsEmployerOnly =
      this.menuItemsWithSubMenu
        ?.filter((menuItem) => menuItem.entitlement !== 'menu-dashboard')
        ?.every(
          (menuItem) => menuItem.entitlement === 'menu-commercial-plans',
        ) || false;
  }

  processLogout(isImpersonatorSignin: boolean) {
    localStorage.setItem('isfromImpersonator', 'true');

    if (this.isOktaLoginEnabled) {
      this._loginFacade.impersonatorLogout();
    } else {
      this.appStateFacade.impersonatorLogOut(isImpersonatorSignin);
    }
  }

  showContactModal() {
    this.dialog.open(ContactUsComponent, {
      width: '40rem',
      autoFocus: false,
      disableClose: true,
    });
  }

  ngOnDestroy() {
    this._ngUnsubscribe$.next();
    this._ngUnsubscribe$.complete();
  }
}
